<template>
    <div>
        <el-input class="search-el" size="mini" v-model="query.title" placeholder="请输入标题"></el-input>
        <el-button type="primary" size="mini" @click="getList()">
            查询
        </el-button>
        <el-button type="primary" size="mini" @click="toCreate()">
            添加
        </el-button>
        <el-button v-if="query.category == 2" type="primary" size="mini" @click="toMeetArticle()">
            遇见专栏活动日历
        </el-button>

        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
                <el-table-column prop="id" label="ID" align="center" min-width="8%"></el-table-column>
                <el-table-column label="标题" align="center" min-width="20%">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="toCreate(row.id)">
                            <div>{{ row.title }}</div>
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" min-width="10%">
                    <template slot-scope="{ row }">
                        <img :src="row.img_url" style="width: 40px" alt="" />
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" align="center" min-width="20%"></el-table-column>

                <el-table-column label="分类" align="center" width="60">
                    <template slot-scope="{ row }">
                        <div>{{ row.category && row.category.name ? row.category.name : '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="排序" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="updateMeetStorySort(row.id)">
                            <div>{{ row.sort }}</div>
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pv" label="页面访问数" align="center" min-width="5%" v-if="query.category != 3"></el-table-column>
                <el-table-column prop="video_num" label="视频数" align="center" min-width="5%" v-if="query.category == 3"></el-table-column>
                <el-table-column prop="pv" label="视频访问数" align="center" min-width="5%" v-if="query.category == 3"></el-table-column>
                <el-table-column prop="uv" label="独立用户访问数" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="id" label="喜欢" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{ row.virtual_like_number }}+{{ row.like_number }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="转发" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{ row.virtual_relay_number }}+{{ row.relay_number }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="是否推荐" align="center" width="60">
                    <template slot-scope="{ row }">
                        <el-switch v-model="row.recommend"
                            :active-value="1"
                            :inactive-value="0"
                            @change="handleMeetStoryRecommend(row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" @click="toStudentStoryList(row.id)" v-if="query.category != 3">
                            <div>学员故事列表</div>
                        </el-button>
                        <el-button type="text" size="mini" @click="
                row.status == 1
                  ? updateMeetStoryStatus(row.id, 0)
                  : updateMeetStoryStatus(row.id, 1)
              ">
                            <div>{{ row.status == 1 ? '下架' : '发布' }}</div>
                        </el-button>

                        <el-button type="danger" size="small" @click="deleteMeetStory(row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
import {
    meetStoryList,
    updateMeetStoryStatus,
    deleteMeetStory,
    updateMeetStorySort,
    updateMeetStoryRecommend,
} from "@/api/story";

export default {
    data: function () {
        return {
            dialogVisible: false,
            list: [],
            loading: false,
            total: 0,
            query: {
                page: 1,
                limit: 20,
                title: "",
                category: this.$route.query.category,
            },
        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        toMeetArticle() {
            this.$router.push({
                path: "/article/info",
                query: {
                    id: 1213,
                },
            });
        },
        toCreate(id) {
            if (this.query.category == 3) {
                this.$router.push({
                    path: "/story/studentStoryVideoInfo",
                    query: {
                        id: id,
                        category: this.$route.query.category,
                    },
                });
            } else {
                this.$router.push({
                    path: "/story/meetStoryInfo",
                    query: {
                        id: id,
                        category: this.$route.query.category,
                    },
                });
            }
        },

        toStudentStoryList(id) {
            this.$router.push({
                path: "/story/meetStudentStoryList",
                query: {
                    id: id,
                    category: this.$route.query.category,
                },
            });
        },

        getList(str) {
            this.loading = true;
            meetStoryList(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },

        updateMeetStorySort(id) {
            this.$prompt("请输入排序", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /[0-9]/,
                inputErrorMessage: "格式不正确",
            })
                .then(({ value }) => {
                    updateMeetStorySort({
                        id: id,
                        sort: value,
                    }).then((response) => {
                        if (response.status == 2000) {
                            this.getList();
                            this.$message({
                                showClose: true,
                                message: "设置成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        updateMeetStoryStatus(id, status) {
            updateMeetStoryStatus({
                id: id,
                status: status,
            }).then((response) => {
                if (response.status == 2000) {
                    this.getList();
                    this.$message({
                        showClose: true,
                        message: "设置成功",
                        type: "success",
                    });
                } /*else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }*/
            });
        },

        deleteMeetStory(id) {
            this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteMeetStory({
                    id: id,
                }).then((response) => {
                    if (response.status == 2000) {
                        this.getList();
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success",
                        });
                    } /*else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }*/
                });
            });
        },
        handleMeetStoryRecommend(row) {
            // this.updateLoading = true
            let params = {
                id: row.id,
                recommend: row.recommend == 1 ? 1 : 0,
            }
            updateMeetStoryRecommend(params).then(response => {
            //   this.updateLoading = false
              if(response.status === '2000'){
                this.$message.success(response.message);
                // this.dialogVisible = false
              }
            });
            },
    },
    mounted() {},
};
</script>